import * as yup from 'yup';

const PayrollDeductionSchema = yup.object().shape({
    amount: yup.number().positive().required(),
    descriptionId: yup.number().integer().positive().required(),
});

export default PayrollDeductionSchema;
